import API from '@/assets/libraries/API_Requests';
import { OfflineModeMiscDataStorage } from '@/services/OfflineMode';

// csc
export async function getSettingDetails() {
	try {
		const response = await API.Call('GET', `${API.CSC_API_URL}/users/settings`);

		if (response.error?.title == 'NO_NETWORK_CONNECTION') {
			//Fallback to local data
			const settings = await OfflineModeMiscDataStorage.getDataForEntityType(OfflineModeMiscDataStorage.ENTITY_TYPES.SETTINGS);
			console.log('Loaded local settings', settings);

			return settings;
		}

		OfflineModeMiscDataStorage.updateEntity({ entity_type: OfflineModeMiscDataStorage.ENTITY_TYPES.SETTINGS, entity_data: response }).catch((error) => {
			console.log('Error storing settings locally', error);
		});

		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

export async function updateSettings(setting_name, setting_value) {
	try {
		const response = await API.Call('PUT', `${API.CSC_API_URL}/users/settings`, { [setting_name]: setting_value });
		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

// ignite settings
export async function getIgniteSettingDetails() {
	try {
		const response = await API.Call('GET', `${API.IGNITE_API_URL}/users/settings`);
		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

export async function updateIgniteSettings(setting_name, setting_value) {
	try {
		const response = await API.Call('PUT', `${API.IGNITE_API_URL}/users/settings`, {
			source: 'IGNITE',
			[setting_name]: setting_value,
		});
		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}
